var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11.75C21.4142 11.75 21.75 12.0858 21.75 12.5V21.5C21.75 21.9142 21.4142 22.25 21 22.25H3C2.58579 22.25 2.25 21.9142 2.25 21.5V12.5042C2.25 12.0899 2.58579 11.7542 3 11.7542C3.41421 11.7542 3.75 12.0899 3.75 12.5042V20.75H20.25V12.5C20.25 12.0858 20.5858 11.75 21 11.75Z",
    fill: "#0E9658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L12 15.4393L15.9697 11.4697C16.2626 11.1768 16.7374 11.1768 17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L12.5303 17.0303C12.2374 17.3232 11.7626 17.3232 11.4697 17.0303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697Z",
    fill: "#0E9658"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9961 2.75C12.4103 2.75 12.7461 3.08579 12.7461 3.5V16.5C12.7461 16.9142 12.4103 17.25 11.9961 17.25C11.5819 17.25 11.2461 16.9142 11.2461 16.5V3.5C11.2461 3.08579 11.5819 2.75 11.9961 2.75Z",
    fill: "#0E9658"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d6bcd50c12e0c52126efb46f8f529d2c.svg";
export { ForwardRef as ReactComponent };